<template>
    <div>
    <button class="c-btn c-btn--secondary c-btn--tiny no-margin" @click="openModalPrice(value)">Bewerken</button>

    <change-product-price
        v-show="modal"
        @close="modal=false"
        @reload="reload"
        :product_id="value">
    </change-product-price>

</div>
</template>



<script>
import Column from '@mixins/Column';
import ChangeProductPrice from '@app/modals/ChangeProductPrice';
export default {
    mixins: [ Column ],
    data() {
        return {
            modal: false,
        }
    },
    components: {
        ChangeProductPrice
    },
    props: {
        emit: {
            type: String,
            required: true
        },
    },
    methods: {
        openModalPrice() {
          this.modal = true;
		},
        reload(){
            this.$store.dispatch('listener/emit', 'reload-prices');
        }
    }
}
</script>
